import { locales, type MarketingLocale } from "./content/types";

export function parsePathname(pathname: string): { locale: MarketingLocale; path: string } {
  const clean = pathname.split(/[?#]/)[0]!.replace(/\/$/, "") || "/";
  const first = clean.split("/")[1];
  const locale = locales.find(value => value !== "el" && value === first) || "el";
  return { locale, path: locale === "el" ? clean : (clean.slice(locale.length + 1) || "/") };
}
export function localePath(path: string, locale: MarketingLocale) {
  return locale === "el" ? path : `/${locale}${path === "/" ? "" : path}`;
}
export function articlePath(locale: MarketingLocale, slug: string) { return localePath(`/blog/${slug}`, locale); }
export function archivePath(locale: MarketingLocale, page = 1, category?: string) {
  return localePath(`/blog${category ? `/category/${category}` : ""}${page > 1 ? `/page/${page}` : ""}`, locale);
}
export function localizeLink(path: string, locale: MarketingLocale) {
  if (!path.startsWith("/") || /^\/(en|de|fr|es|it|pt)(\/|$)/.test(path)) return path;
  const target = path === "/" || path.startsWith("/blog") || locale === "el" || locale === "en" ? locale : "en";
  return localePath(path, target);
}
